import { Voucher, createUnblockVoucherMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockVoucherModel = ConfirmModalModel<Voucher, number, Voucher>;

export const createUnblockVoucherModel = (): UnblockVoucherModel => {
	const unblockVoucherMutation = createUnblockVoucherMutation();

	const model = createConfirmModalModel<Voucher, number, Voucher>({
		modalData: declareModalData<Voucher>(),
		mapModalData: ({ id }) => id,
		mutation: unblockVoucherMutation,
		successMessageKey: 'unblock-voucher.success',
	});

	return model;
};
